import React, { Suspense } from "react";
import { PRODUCT_STEPS_MAP } from "../helpers/productSteps";

const LoadComponent = ({
  productType,
  step,
  t,
  profile,
  isLoading,
  handlePrevStep,
  handleNextStep,
}) => {
  const StepsMap = PRODUCT_STEPS_MAP[productType];
  if (!StepsMap) return null;

  const StepComponent = StepsMap[step];
  if (!StepComponent) return null;

  const stepProps = {
    step,
    t,
    profile,
    isLoading,
    handlePrevStep,
    handleNextStep,
  };

  return (
    <Suspense
      fallback={
        <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
          <div className="loader" />
        </div>
      }
    >
      <StepComponent {...stepProps} />
    </Suspense>
  );
};

export default LoadComponent;
